import React, { useState } from "react";
import configrations from "../../config/configrations";

export default function UserSearchCard({ getUser, onUserFound }) {
  const [accountNumber, setAccountNumber] = useState("");
  const [user, setUser] = useState(null);

  const handleSearch = async () => {
    try {
      const res = await getUser(accountNumber);
      const data = res?.data?.data;
      setUser(data);
      onUserFound(data); // send to parent
    } catch {
      alert("User not found");
    }
  };

  return (
    <>
      <input
        className="form-control mt-2"
        placeholder="Enter Account Number"
        value={accountNumber}
        onChange={(e) => setAccountNumber(e.target.value)}
      />
      <button className="btn btn-primary mt-2 w-100" onClick={handleSearch}>
        Search User
      </button>

      {user && (
        <div className="mt-3 p-3 border rounded">
          <div className="row">
            <div className="col-md-4 text-center">
              <img
                src={`${configrations.backendBaseDomain}${user.image}`}
                alt=""
                style={{ height: 80, width: 80, borderRadius: "50%" }}
              />
            </div>
            <div className="col-md-8">
              <h5>{user.name}</h5>
              <p>A/C: {user.accountNumber}</p>
              <p>₹ {user.totalAmount}</p>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
